import infoGreen from 'assets/images/account-page/info-green.svg';
import savesExportsIcon from 'assets/images/plan-saves-exports.svg';
import leadAutomatorIcon from 'assets/images/plan-lead-automator.svg';
import teamMemberIcon from 'assets/images/plan-team.svg';
import skipTracingIcon from 'assets/images/plan-skip-tracing.svg';
import classNames from "classnames";
import React, { useRef, useEffect } from "react";
import css from "../style.scss";
import { useDispatch, useSelector } from 'react-redux';
import { selectPlanDetails, updateSelectedChooseTierTooltip } from '../../../../data/user';
import SVG from 'components/base/SVG';

import giftGreen from 'assets/images/plan-description/plan-gift.svg';
import planBatchdialer from 'assets/images/plan-description/plan-batchdialer.svg';
import accessKey from 'assets/images/plan-description/plan-access.svg';
import callSettings from 'assets/images/plan-description/plan-call-setting-green.svg';
import planPostcard from 'assets/images/plan-description/plan-postcard-green.svg';
import intelligenceIcon from 'assets/images/plan-description/plan-intelligence.svg';


const MonthlyEliteIncludes = () => {

    const containerRef = useRef(null);

    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `monthlyElite-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);

    return (
        <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={giftGreen} className={css.clsIncludesIcon} alt="7-Day Free Trial" />
                <p>
                    <strong>7-Day Free Trial</strong> With 50 Free Leads
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('trial')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-trial',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Free Trial <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Take a week and explore everything your <b>PropStream</b> plan has to offer.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={savesExportsIcon} className={css.clsIncludesIcon} alt="Monthly Saves & Exports" />
                <p>
                    <strong>100,000 </strong>
                    Monthly Saves & Exports
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('saves')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-saves',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Saves & Exports <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}><b>PropStream</b> makes it easy to save, export, and organize your real estate leads for effective marketing and outreach. Quickly export your leads to use with other tools and keep your records up to date. Additional saves and exports are available for purchase.</p>
                            <p className={css.clsInfoContentPara}><b><i>NOTE: Unused saves and exports don't roll over. Each month your account resets to your regular limit.</i></b></p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={accessKey} className={css.clsIncludesIcon} alt="Access to Web & Mobile Platforms" />
                <p>Access to Web & Mobile Platforms</p>
            </li>
            <li>
                <img src={teamMemberIcon} className={css.clsIncludesIcon} alt="9 Full Access Team Members Included" />
                <p>
                    9 Full Access Team Members <br/>Included
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('team')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-team',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Team Members <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Perfect for large teams! Get 9 team members included!</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={leadAutomatorIcon} className={css.clsIncludesIcon} alt="Lead Automator" />
                <p>
                    <strong>Lead Automator: </strong>
                    120,000 Properties
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('automator')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-automator',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Lead Automator <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Automatically track and get updates on 120,000 properties with custom filters. <b>Lead Automator</b> updates and refines your real estate lead lists based on custom filters, ensuring you always have the freshest opportunities at your fingertips. It's like having a personal assistant for your pipeline!</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={intelligenceIcon} className={css.clsIncludesIcon} alt="PropStream Intelligence" />
                <p>
                    <strong>PropStream Intelligence Assistant</strong> Included
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('intelligence')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-intelligence',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>PropStream Intelligence <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Ask questions, get instant property insights, and analyze deals with the PropStream Intelligence Assistant.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={skipTracingIcon} className={css.clsIncludesIcon} alt="Free Skip Tracing" />
                <p>
                    <strong>Free Skip Tracing:</strong> Worth $12,000
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('tracing')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-tracing',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Skip Tracing <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Need more contact details? <b>Free Skip Tracing</b> is available to the main account holder, via our third-party vendor, and helps you uncover phone numbers and emails for your leads, giving you the tools to connect directly and efficiently. Say goodbye to dead ends and hello to new opportunities.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={callSettings} className={css.clsIncludesIcon} alt="Free Skip Tracing" />
                <p>
                    <strong>Free Click-to-Dial Calling</strong> Included
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('calling')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-calling',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Click-to-Dial Calling <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>With PropStream's Click-to-Dial, you can instantly call property owners directly inside the platform using a built-in softphone. Simply click a phone number to start a live call, supported by ranked contact data and AI-guided prompts—no exports or extra tools required. Just faster, more confident outreach with your skip-traced leads.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <SVG icon='chartIconPlan' className={css.clsIncludesIcon} width = {22} height={22} />
                <p><strong>Marketing Campaigns</strong> Track calls, emails sent & opened, & postcards sent</p>
            </li>
            <li>
                <img src={planPostcard} className={css.clsIncludesIcon} alt="Save on Postcards" />
                <p><strong>Save on Postcards,</strong> prices as low as 48¢</p>
            </li>
            <li>
                <img src={planBatchdialer} className={css.clsIncludesIcon} alt="BatchDialer" />
                <p>
                    <strong>BatchDialer</strong> (Lifetime 20% off In-app)
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('batchdialer')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-batchdialer',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>BatchDialer <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Unlock 20% off after you start your PropStream trial using the in-app promotion.</p>
                        </div>
                    </span>
                </p>
            </li>
        </div>
    );
};

export default MonthlyEliteIncludes;
